import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeDeleteItemStatusDialog } from "./item-status-delete-slice";
import { db } from "../../../../firebase";
import { useEffect, useState } from "react";
import { deleteItemStatusService } from "./item-status-delete-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
};

const ItemStatusDelete = () => {
    const classes = useStyles();
    const itemStatusData = useSelector((state) => state.itemStatusDeleteSlice.itemStatusDelete);
    const showDialog = useSelector((state) => state.itemStatusDeleteSlice.showDialog);
    const isLoading = useSelector((state) => state.itemStatusDeleteSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const dispatch = useDispatch();

    const itemStatusId = itemStatusData.id;

    // get data
    useEffect(() => {
        if (showDialog) {
            setFormData(itemStatusData);
        }
    }, [showDialog, itemStatusData]);

    // handle delete
    const handleDeleteSubmit = async (e) => {
        try {
            await deleteItemStatusService(dispatch, db, "item_status", itemStatusId)
        } catch (e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to delete."));
            console.error("ItemStatusDelete handleDeleteSubmit error: ", e);
        }

        handleDeleteClose();
    };

    // handle close delete
    const handleDeleteClose = () => {
        dispatch(closeDeleteItemStatusDialog());
    };

    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Delete Item Status
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.text}>
                    {`Do you want to delete '${formData?.code} - ${formData?.name}'?`}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleDeleteSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Deleting..."
                        ) : (
                            "Delete"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleDeleteClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemStatusDelete;